<template>
    <div class="installsure-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Insurance-backed Guarantees in partnership with Installsure
                </div>
                <div class="logo">
                    <img src="/images/installsure-logo-small.jpg" style="height: 35px;">
                </div>
            </div>
            <div class="box-1">
                <h1>About Installsure guarantee insurance</h1>
                <p>
                  Installsure guarantee insurance insures your installer’s guarantee against the risk of your company becoming insolvent.

                </p>
              <p>
                <strong>Approved IBG provider for Competent Person Schemes including FENSA</strong>
              </p>
              <p>
                If you want to self-certify the compliance of your replacement window or door installations with Building Regulations in England or Wales, you’ll need to join a Competent Person Scheme such as FENSA.
              </p>
              <p>
                All CPS members must be registered with an approved IBG provider, such as Installsure.
              </p>
              <p>
                Once you are up and running as an Installsure registered business, it is a simple matter of making sure the policies are registered with us so we can send them to your clients.
              </p>
              <div>
                <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                  Make Enquiry
                </a>
              </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/installer-benefits-insurance-backed-gurarantees-header.jpg">
            </div>
            <div class="box-2">
              <h1>How much do Installsure IBGs cost?</h1>
                <p>
                  How much you pay for guarantee insurance policies will depend on the contract value of the works carried out, the type of works installed, and in some cases whether deposit cover is also required. Installsure IBGs can start from as low as £11.98 (including insurance premium tax) per window/door installation. For more information see our Guarantee Insurance Pricing Guide below.
                </p>
              <div>
                <table class="table _bordered">
                  <tr>
                    <td colspan="2">Glass & Glazing Federation (GGF) Members</td>
                  </tr>
                  <tr>
                    <td>
                      Windows, doors, roofline
                      < £25k
                    </td>
                    <td>
                      £11.98
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Conservatories
                      < £25
                    </td>
                    <td>
                      £20.29
                    </td>
                  </tr>
                  <tr>
                    <td>
                      All Installations
                      £25 - 30k
                    </td>
                    <td>
                      £47.99
                    </td>
                  </tr>
                  <tr>
                    <td>
                      All Installations
                      > £30k
                    </td>
                    <td>
                      Contact us for pricing
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      Inclusive of 12% IPT (Insurance Premium Tax)
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">All other companies trading for more than 18 months</td>
                  </tr>
                  <tr>
                    <td>
                      Windows, doors, roofline
                      < £25k
                    </td>
                    <td>
                      £16.77
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Conservatories
                      < £25
                    </td>
                    <td>
                      £23.98
                    </td>
                  </tr>
                  <tr>
                    <td>
                      All Installations
                      £25 - 30k
                    </td>
                    <td>
                      £47.99
                    </td>
                  </tr>
                  <tr>
                    <td>
                      All Installations
                      > £30k
                    </td>
                    <td>
                      Contact us for pricing
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      Inclusive of 12% IPT (Insurance Premium Tax)
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          <div class="box-3">
            <h1>What trades do Installsure IBGs cover? </h1>
            <p>
              We’re proud to be a leading provider of guarantee insurance to the glazing sector, including some of the industry’s biggest names. Yet Installsure specialises in IBGs for all sorts of home improvement installation work, including:
            </p>
            <p>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> All forms of glazing/UPVC installation work including windows, doors, conservatories and roofline products</span>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> Roofing products including complete re-roofs and a specialised scheme relating to the Andura Roof-Coating system</span>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> Bathroom installations</span>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> Loft conversions</span>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> Concrete driveways</span>
              <span class="block mb-1"><i class="fa fa-check mr-1"></i> Garage doors</span>
              <span class="block"><i class="fa fa-check mr-1"></i> General building work</span>
            </p>
            <p>
              Need guarantee cover for a type of installation work not on this list? Contact our team today and we’ll see what we can do.
            </p>
            <div>
              <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                Contact our team
              </a>
            </div>
          </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Insurance Backed Guarantees Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for Installsure',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 16,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Installsure enquiry',
                'value': 'Installsure enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Installsure`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Installsure partner link clicked',
          'value': 'Installsure partner link clicked',
        });
      },
    },
};
</script>
